import Odoo from './Odoo';

class AuthAPIClass{
    logUserIn(login, password, pack_password){
      var params = [login, password, pack_password];
      return new Promise((resolve, reject) => {
        Odoo.call('', 'login', params, login, password, pack_password).then(res => {
          if(!res){
            reject(new TypeError('Login lub hasło nieprawidłowe'))
          } else {
            resolve(res)
          }
        }).catch(err=>{
          reject(err)
        })
      });
    }

    getPartner(id){
      var params = [
        id,
        [ 'name' ]
      ];
      return new Promise((resolve, reject) => {
        Odoo.connect().then(api => {
          api.execute_kw('res.partner', 'read', [params], function (err, partner) {
            if (err) reject(err);
            resolve(partner[0]);
          });
        });
      });
    }
}

const AuthAPI = new AuthAPIClass();

export default AuthAPI;



// WEBPACK FOOTER //
// ./src/utils/AuthAPI.js